import DetermineCollapsedLengthScreen from "@dana/Components/EZID/DetermineCollapsedLengthScreen";
import DetermineInstalledLengthScreen from "@dana/Components/EZID/DetermineInstalledLengthScreen";
import JointAngleSelectorScreen from "@dana/Components/EZID/JointAngleSelectorScreen";
import LengthSelectorScreen from "@dana/Components/EZID/LengthSelectorScreen";
import PhaseSelectorScreen from "@dana/Components/EZID/PhaseSelectorScreen";
import ResultScreen from "@dana/Components/EZID/ResultScreen";
import SeriesSelectorScreen from "@dana/Components/EZID/SeriesSelectorScreen";
import UJointStyleSelectorScreen from "@dana/Components/EZID/UJointStyleSelectorScreen";
import { EZIDAttributeFilter } from "@dana/Types/EZIDAttributeFilter";
import { WizardStep } from "@dana/Types/WizardStep";
import { useShellContext } from "@insite/client-framework/Components/IsInShell";
import Zone from "@insite/client-framework/Components/Zone";
import { get } from "@insite/client-framework/Services/ApiService";
import { useGetLink } from "@insite/client-framework/Store/Links/LinksSelectors";
import {
    ExcludeFromNavigation,
    ExcludeFromSignInRequired,
    HideFooter,
    HideFromSearchEngines,
    HideFromSiteSearch,
    HideHeader,
    HorizontalRule,
    LinkFieldValue,
    MetaDescription,
    MetaKeywords,
    OpenGraphImage,
    OpenGraphTitle,
    OpenGraphUrl,
    StructuredPageData,
} from "@insite/client-framework/Types/FieldDefinition";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import Page from "@insite/mobius/Page";
import { useHistory } from "@insite/mobius/utilities/HistoryContext";
import * as React from "react";
import { useEffect, useState } from "react";


const enum fields {
    // Main Page
    pageHeading = "pageHeading",
    pageSubText = "pageSubText",
    backLabel = "backLabel",
    shortCouleSelectionUrl = "shortCouleSelectionUrl",
    watchVideoLabel = "watchVideoLabel",
    nextLabel = "nextLabel",
    stepLabel = "stepLabel",

    // Step 1 - Select Series
    selectSeriesHeading = "selectSeriesHeading",
    seriesLabel = "seriesLabel",
    selectSeriesImage = "selectSeriesImage",
    selectSeriesImageAltText = "selectSeriesImageAltText",
    selectSeriesLeftNote = "selectSeriesLeftNote",
    selectSeriesRightNote = "selectSeriesRightNote",
    selectSeriesVideo = "selectSeriesVideo",
    selectSeriesVideoCaption = "selectSeriesVideoCaption",

    // Step 2 - Select U-Joint Style
    selectUJointStyleHeading = "selectUJointStyleHeading",
    uJointStyleLabel = "uJointStyleLabel",
    selectUJointStyleImage = "selectUJointStyleImage",
    selectUJointStyleImageAltText = "selectUJointStyleImageAltText",
    selectUJointStyleLeftNote = "selectUJointStyleLeftNote",
    selectUJointStyleRightNote = "selectUJointStyleRightNote",
    selectUJointStyleVideo = "selectUJointStyleVideo",
    selectUJointStyleVideoCaption = "selectUJointStyleVideoCaption",

    // Step 3 - Determine Collapsed Length
    determineCollapsedLengthHeading = "determineCollapsedLengthHeading",
    determineCollapsedLengthImage = "determineCollapsedLengthImage",
    determineCollapsedLengthImageAltText = "determineCollapsedLengthImageAltText",
    determineCollapsedLength1stOptionLabel = "determineCollapsedLength1stOptionLabel",
    determineCollapsedLength2ndOptionLabel = "determineCollapsedLength2ndOptionLabel",
    determineCollapsedLength3rdOptionLabel = "determineCollapsedLength3rdOptionLabel",
    determineCollapsedLength4thOptionLabel = "determineCollapsedLength4thOptionLabel",
    determineCollapsedLengthVideo = "determineCollapsedLengthVideo",
    determineCollapsedLengthVideoCaption = "determineCollapsedLengthVideoCaption",
    determineCollapsedLengthLeftNote = "determineCollapsedLengthLeftNote",
    determineCollapsedLengthRightNote = "determineCollapsedLengthRightNote",
    collapsedCLYokeToCLYokeHeading = "collapsedCLYokeToCLYokeHeading",
    collapsedCLYokeToCLYokeImage = "collapsedCLYokeToCLYokeImage",
    collapsedCLYokeToCLYokeImageAltText = "collapsedCLYokeToCLYokeImageAltText",
    collapsedCLYokeToCLYokeMMLabel = "collapsedCLYokeToCLYokeMMLabel",
    collapsedCLYokeToCLYokeINLabel = "collapsedCLYokeToCLYokeINLabel",
    collapsedFFToFFHeading = "collapsedFFToFFHeading",
    collapsedFFToFFImage = "collapsedFFToFFImage",
    collapsedFFToFFImageAltText = "collapsedFFToFFImageAltText",
    collapsedFFToFFMMLabel = "collapsedFFToFFMMLabel",
    collapsedFFToFFINLabel = "collapsedFFToFFINLabel",
    collapsedCLYokeToFFHeading = "collapsedCLYokeToFFHeading",
    collapsedCLYokeToFFImage = "collapsedCLYokeToFFImage",
    collapsedCLYokeToFFImageAltText = "collapsedCLYokeToFFImageAltText",
    collapsedCLYokeToFFMMLabel = "collapsedCLYokeToFFMMLabel",
    collapsedCLYokeToFFINLabel = "collapsedCLYokeToFFINLabel",

    // Step 4 - Determine Installed Length
    determineInstalledLengthHeading = "determineInstalledLengthHeading",
    determineInstalledLengthAdditionalHeading = "determineInstalledLengthAdditionalHeading",
    determineInstalledLengthImage = "determineInstalledLengthImage",
    determineInstalledLengthImageAltText = "determineInstalledLengthImageAltText",
    determineInstalledLength1stOptionLabel = "determineInstalledLength1stOptionLabel",
    determineInstalledLength2ndOptionLabel = "determineInstalledLength2ndOptionLabel",
    determineInstalledLength3rdOptionLabel = "determineInstalledLength3rdOptionLabel",
    determineInstalledLengthVideo = "determineInstalledLengthVideo",
    determineInstalledLengthVideoCaption = "determineInstalledLengthVideoCaption",
    determineInstalledLengthLeftNote = "determineInstalledLengthLeftNote",
    determineInstalledLengthRightNote = "determineInstalledLengthRightNote",
    installedCLYokeToCLYokeHeading = "installedCLYokeToCLYokeHeading",
    installedCLYokeToCLYokeImage = "installedCLYokeToCLYokeImage",
    installedCLYokeToCLYokeImageAltText = "installedCLYokeToCLYokeImageAltText",
    installedCLYokeToCLYokeMMLabel = "installedCLYokeToCLYokeMMLabel",
    installedCLYokeToCLYokeINLabel = "installedCLYokeToCLYokeINLabel",
    installedFFToFFHeading = "installedFFToFFHeading",
    installedFFToFFImage = "installedFFToFFImage",
    installedFFToFFImageAltText = "installedFFToFFImageAltText",
    installedFFToFFMMLabel = "installedFFToFFMMLabel",
    installedFFToFFINLabel = "installedFFToFFINLabel",
    installedCLYokeToFFHeading = "installedCLYokeToFFHeading",
    installedCLYokeToFFImage = "installedCLYokeToFFImage",
    installedCLYokeToFFImageAltText = "installedCLYokeToFFImageAltText",
    installedCLYokeToFFMMLabel = "installedCLYokeToFFMMLabel",
    installedCLYokeToFFINLabel = "installedCLYokeToFFINLabel",

    // Step 5 - Select Phasing
    selectPhasingHeading = "selectPhasingHeading",
    phasingLabel = "phasingLabel",
    selectPhasingImage = "selectPhasingImage",
    selectPhasingImageAltText = "selectPhasingImageAltText",
    selectPhasingLeftNote = "selectPhasingLeftNote",
    selectPhasingRightNote = "selectPhasingRightNote",
    selectPhasingVideo = "selectPhasingVideo",
    selectPhasingVideoCaption = "selectPhasingVideoCaption",

    // Step 6 - Select Joint Angle
    selectJointAngleHeading = "selectJointAngleHeading",
    jointAngleLabel = "jointAngleLabel",
    selectJointAngleImage = "selectJointAngleImage",
    selectJointAngleImageAltText = "selectJointAngleImageAltText",
    selectJointAngleLeftNote = "selectJointAngleLeftNote",
    selectJointAngleRightNote = "selectJointAngleRightNote",
    selectJointAngleVideo = "selectJointAngleVideo",
    selectJointAngleVideoCaption = "selectJointAngleVideoCaption",

    // Result Page
    productDefaultImage = "productDefaultImage",
    productDefaultImageAltText = "productDefaultImageAltText",
    promotionalImage = "promotionalImage",
    promotionalImageAltText = "promotionalImageAltText",
    promotionalText = "promotionalText",
    promotionalURL = "promotionalURL",
    viewAdditionalDetailLabel = "viewAdditionalDetailLabel",
}

interface OwnProps extends PageProps {
    fields: {
        // Main Page
        pageHeading: string;
        pageSubText: string;
        backLabel: string;
        shortCouleSelectionUrl: LinkFieldValue;
        watchVideoLabel: string;
        nextLabel: string;
        stepLabel: string;

        // Step 1 - Select Series
        selectSeriesHeading: string;
        seriesLabel: string;
        selectSeriesImage: string;
        selectSeriesImageAltText: string;
        selectSeriesLeftNote: string;
        selectSeriesRightNote: string;
        selectSeriesVideo: LinkFieldValue;
        selectSeriesVideoCaption: LinkFieldValue;

        // Step 2 - Select U-Joint Style
        selectUJointStyleHeading: string;
        uJointStyleLabel: string;
        selectUJointStyleImage: string;
        selectUJointStyleImageAltText: string;
        selectUJointStyleLeftNote: string;
        selectUJointStyleRightNote: string;
        selectUJointStyleVideo: LinkFieldValue;
        selectUJointStyleVideoCaption: LinkFieldValue;

        // Step 3 - Determine Collapsed Length
        determineCollapsedLengthHeading: string;
        determineCollapsedLengthImage: string;
        determineCollapsedLengthImageAltText: string;
        determineCollapsedLength1stOptionLabel: string;
        determineCollapsedLength2ndOptionLabel: string;
        determineCollapsedLength3rdOptionLabel: string;
        determineCollapsedLength4thOptionLabel: string;
        determineCollapsedLengthVideo: LinkFieldValue;
        determineCollapsedLengthVideoCaption: LinkFieldValue;
        determineCollapsedLengthLeftNote: string;
        determineCollapsedLengthRightNote: string;
        collapsedCLYokeToCLYokeHeading: string;
        collapsedCLYokeToCLYokeImage: string;
        collapsedCLYokeToCLYokeImageAltText: string;
        collapsedCLYokeToCLYokeMMLabel: string;
        collapsedCLYokeToCLYokeINLabel: string;
        collapsedFFToFFHeading: string;
        collapsedFFToFFImage: string;
        collapsedFFToFFImageAltText: string;
        collapsedFFToFFMMLabel: string;
        collapsedFFToFFINLabel: string;
        collapsedCLYokeToFFHeading?: string;
        collapsedCLYokeToFFImage?: string;
        collapsedCLYokeToFFImageAltText?: string;
        collapsedCLYokeToFFMMLabel?: string;
        collapsedCLYokeToFFINLabel?: string;

        // Step 4 - Determine Installed Length
        determineInstalledLengthHeading?: string;
        determineInstalledLengthAdditionalHeading?: string;
        determineInstalledLengthImage?: string;
        determineInstalledLengthImageAltText?: string;
        determineInstalledLength1stOptionLabel?: string;
        determineInstalledLength2ndOptionLabel?: string;
        determineInstalledLength3rdOptionLabel?: string;
        determineInstalledLengthVideo?: LinkFieldValue;
        determineInstalledLengthVideoCaption?: LinkFieldValue;
        determineInstalledLengthLeftNote?: string;
        determineInstalledLengthRightNote?: string;
        installedCLYokeToCLYokeHeading?: string;
        installedCLYokeToCLYokeImage?: string;
        installedCLYokeToCLYokeImageAltText?: string;
        installedCLYokeToCLYokeMMLabel?: string;
        installedCLYokeToCLYokeINLabel?: string;
        installedFFToFFHeading?: string;
        installedFFToFFImage?: string;
        installedFFToFFImageAltText?: string;
        installedFFToFFMMLabel?: string;
        installedFFToFFINLabel?: string;
        installedCLYokeToFFHeading?: string;
        installedCLYokeToFFImage?: string;
        installedCLYokeToFFImageAltText?: string;
        installedCLYokeToFFMMLabel?: string;
        installedCLYokeToFFINLabel?: string;

        // Step 5 - Select Phasing
        selectPhasingHeading?: string;
        phasingLabel?: string;
        selectPhasingImage?: string;
        selectPhasingImageAltText?: string;
        selectPhasingLeftNote?: string;
        selectPhasingRightNote?: string;
        selectPhasingVideo?: LinkFieldValue;
        selectPhasingVideoCaption?: LinkFieldValue;

        // Step 6 - Select Joint Angle
        selectJointAngleHeading?: string;
        jointAngleLabel?: string;
        selectJointAngleImage?: string;
        selectJointAngleImageAltText?: string;
        selectJointAngleLeftNote?: string;
        selectJointAngleRightNote?: string;
        selectJointAngleVideo?: LinkFieldValue;
        selectJointAngleVideoCaption?: LinkFieldValue;

        // Result Page
        productDefaultImage?: string;
        productDefaultImageAltText?: string;
        promotionalImage?: string;
        promotionalImageAltText?: string;
        promotionalText?: string;
        promotionalURL?: LinkFieldValue;
        viewAdditionalDetailLabel?: string;
    };
}

const EZIDShortCoupleWorkflowPage = ({ id, fields }: OwnProps) => {
    const [stepStack, setStepStack] = useState<WizardStep[]>([{ main: 0 }]);
    const currentStep = stepStack[stepStack.length - 1];

    const [readyshaftCategoryId, setreadyshaftCategoryId] = useState("");
    const [spicerReadyShaftBrandId, setspicerReadyShaftBrandId] = useState("");
    const [invoiceAttributeValueId, setinvoiceAttributeValueId] = useState("");
    const [attributeFilters, setAttributeFilters] = useState<EZIDAttributeFilter[]>([]);
    const { isInShell } = useShellContext();
    const history = useHistory();
    const { url } = useGetLink(fields.shortCouleSelectionUrl);

    useEffect(() => {
        const fetchFilters = async () => {

           get("/api/v1/ezid/getSpicerReadyShaftFilters?workflow=short-couple").then((data: any) => {
                setreadyshaftCategoryId(data?.readyshaftCategoryId);
                setspicerReadyShaftBrandId(data?.spicerReadyShaftBrandId);
                setinvoiceAttributeValueId(data?.invoiceAttributeValueId);
                setAttributeFilters([{
                    attributeTypeName: 'Type',
                    attributeValueId: data.invoiceAttributeValueId,
                    attributeValueName: 'Short Couple',
                }]);
                setStepStack(prev => [...prev, { main: 1 }]); // move to step 1 after fetching filters

            }).catch((error) => {
                console.error("Error fetching filters:", error);
            })

        };

        fetchFilters();
    }, []);

    const proceedToNextScreen = (newAttributeFilters?: EZIDAttributeFilter[], subStep?: number) => {
        if (newAttributeFilters) {
            setAttributeFilters(newAttributeFilters);
        }
        const nextStep = subStep ? { main: currentStep.main, sub: subStep } : { main: currentStep.main + 1 };
        setStepStack(prev => [...prev, nextStep]);
    };

    const proceedToPreviousScreen = (newAttributeFilters?: EZIDAttributeFilter[]) => {
        if (newAttributeFilters) {
            setAttributeFilters(newAttributeFilters);
        }

        if (currentStep.main > 1) {
            setStepStack(prev => prev.length > 1 ? prev.slice(0, -1) : prev);
        } else {
            if (!url) {
                return;
            }

            if (url.startsWith("http")) {
                if (isInShell) {
                    return;
                }
                window.location.href = url;
            } else {
                history.push(url);
            }
        }
    }

    return (
        <Page>
            <Zone contentId={id} zoneName="Content" requireRows />
            {currentStep.main === 1 && (
                <SeriesSelectorScreen
                    onProceedToNextScreen={proceedToNextScreen}
                    onProceedToPreviousScreen={proceedToPreviousScreen}
                    readyshaftCategoryId={readyshaftCategoryId}
                    currentAttributeFilters={attributeFilters}
                    video={fields.selectSeriesVideo}
                    caption={fields.selectSeriesVideoCaption}
                    backLabel={fields.backLabel}
                    slideTitle={fields.pageHeading}
                    subText={fields.pageSubText}
                    description={fields.selectSeriesHeading}
                    image={fields.selectSeriesImage}
                    imageAltText={fields.selectSeriesImageAltText}
                    facetLabel={fields.seriesLabel}
                    leftNote={fields.selectSeriesLeftNote}
                    rightNote={fields.selectSeriesRightNote}
                    watchVideoLabel={fields.watchVideoLabel}
                    stepLabel={fields.stepLabel}
                    nextLabel={fields.nextLabel}
                    step={1}
                />
            )}
            {currentStep.main === 2 && (
                <UJointStyleSelectorScreen
                    onProceedToNextScreen={proceedToNextScreen}
                    onProceedToPreviousScreen={proceedToPreviousScreen}
                    readyshaftCategoryId={readyshaftCategoryId}
                    currentAttributeFilters={attributeFilters}
                    video={fields.selectUJointStyleVideo}
                    caption={fields.selectUJointStyleVideoCaption}
                    backLabel={fields.backLabel}
                    slideTitle={fields.pageHeading}
                    subText={fields.pageSubText}
                    description={fields.selectUJointStyleHeading}
                    image={fields.selectUJointStyleImage}
                    imageAltText={fields.selectUJointStyleImageAltText}
                    facetLabel={fields.uJointStyleLabel}
                    leftNote={fields.selectUJointStyleLeftNote}
                    rightNote={fields.selectUJointStyleRightNote}
                    watchVideoLabel={fields.watchVideoLabel}
                    stepLabel={fields.stepLabel}
                    nextLabel={fields.nextLabel}
                    step={2}
                />
            )}
            {currentStep.main === 3 && !currentStep.sub && (
                <DetermineCollapsedLengthScreen
                    onProceedToNextScreen={proceedToNextScreen}
                    onProceedToPreviousScreen={proceedToPreviousScreen}
                    video={fields.determineCollapsedLengthVideo}
                    caption={fields.determineCollapsedLengthVideoCaption}
                    backLabel={fields.backLabel}
                    slideTitle={fields.pageHeading}
                    subText={fields.pageSubText}
                    description={fields.determineCollapsedLengthHeading}
                    image={fields.determineCollapsedLengthImage}
                    imageAltText={fields.determineCollapsedLengthImageAltText}
                    determineCollapsedLength1stOptionLabel={fields.determineCollapsedLength1stOptionLabel}
                    determineCollapsedLength2ndOptionLabel={fields.determineCollapsedLength2ndOptionLabel}
                    determineCollapsedLength3rdOptionLabel={fields.determineCollapsedLength3rdOptionLabel}
                    determineCollapsedLength4thOptionLabel={fields.determineCollapsedLength4thOptionLabel}
                    watchVideoLabel={fields.watchVideoLabel}
                    stepLabel={fields.stepLabel}
                    step={3}
                />
            )}
            {currentStep.main === 3 && currentStep.sub === 2 && (
                <LengthSelectorScreen
                    onProceedToNextScreen={proceedToNextScreen}
                    onProceedToPreviousScreen={proceedToPreviousScreen}
                    readyshaftCategoryId={readyshaftCategoryId}
                    currentAttributeFilters={attributeFilters}
                    backLabel={fields.backLabel}
                    slideTitle={fields.pageHeading}
                    subText={fields.pageSubText}
                    description={fields.collapsedCLYokeToCLYokeHeading}
                    image={fields.collapsedCLYokeToCLYokeImage}
                    imageAltText={fields.collapsedCLYokeToCLYokeImageAltText}
                    leftFacetLabel={fields.collapsedCLYokeToCLYokeMMLabel}
                    rightFacetLabel={fields.collapsedCLYokeToCLYokeINLabel}
                    leftNote={fields.determineCollapsedLengthLeftNote}
                    rightNote={fields.determineCollapsedLengthRightNote}
                    stepLabel={fields.stepLabel}
                    nextLabel={fields.nextLabel}
                    step={3}
                    attributeNameInMillimeters="CL Yoke To CL Yoke (MM)-COLL"
                    attributeNameInInches="CL Yoke To CL Yoke (IN)-COLL"
                />
            )}
            {currentStep.main === 3 && currentStep.sub === 3 && (
                <LengthSelectorScreen
                    onProceedToNextScreen={proceedToNextScreen}
                    onProceedToPreviousScreen={proceedToPreviousScreen}
                    readyshaftCategoryId={readyshaftCategoryId}
                    currentAttributeFilters={attributeFilters}
                    backLabel={fields.backLabel}
                    slideTitle={fields.pageHeading}
                    subText={fields.pageSubText}
                    description={fields.collapsedFFToFFHeading}
                    image={fields.collapsedFFToFFImage}
                    imageAltText={fields.collapsedFFToFFImageAltText}
                    leftFacetLabel={fields.collapsedFFToFFMMLabel}
                    rightFacetLabel={fields.collapsedFFToFFINLabel}
                    leftNote={fields.determineCollapsedLengthLeftNote}
                    rightNote={fields.determineCollapsedLengthRightNote}
                    stepLabel={fields.stepLabel}
                    nextLabel={fields.nextLabel}
                    step={3}
                    attributeNameInMillimeters="FF(Flange Face) To FF (MM)-COLL"
                    attributeNameInInches="FF(Flange Face) To FF (IN)-COLL"
                />
            )}
            {currentStep.main === 3 && currentStep.sub === 4 && (
                <LengthSelectorScreen
                    onProceedToNextScreen={proceedToNextScreen}
                    onProceedToPreviousScreen={proceedToPreviousScreen}
                    readyshaftCategoryId={readyshaftCategoryId}
                    currentAttributeFilters={attributeFilters}
                    backLabel={fields.backLabel}
                    slideTitle={fields.pageHeading}
                    subText={fields.pageSubText}
                    description={fields.collapsedCLYokeToFFHeading}
                    image={fields.collapsedCLYokeToFFImage}
                    imageAltText={fields.collapsedCLYokeToFFImageAltText}
                    leftFacetLabel={fields.collapsedCLYokeToFFMMLabel}
                    rightFacetLabel={fields.collapsedCLYokeToFFINLabel}
                    leftNote={fields.determineCollapsedLengthLeftNote}
                    rightNote={fields.determineCollapsedLengthRightNote}
                    stepLabel={fields.stepLabel}
                    nextLabel={fields.nextLabel}
                    step={3}
                    attributeNameInMillimeters="CL Yoke To Flange Face (MM)-COLL"
                    attributeNameInInches="CL Yoke To Flange Face(IN)-COLL"
                />
            )}

            {currentStep.main === 4 && !currentStep.sub && (
                <DetermineInstalledLengthScreen
                    onProceedToNextScreen={proceedToNextScreen}
                    onProceedToPreviousScreen={proceedToPreviousScreen}
                    video={fields.determineInstalledLengthVideo}
                    caption={fields.determineInstalledLengthVideoCaption}
                    backLabel={fields.backLabel}
                    slideTitle={fields.pageHeading}
                    subText={fields.pageSubText}
                    description={fields.determineInstalledLengthHeading}
                    additionalText={fields.determineInstalledLengthAdditionalHeading}
                    image={fields.determineInstalledLengthImage}
                    imageAltText={fields.determineInstalledLengthImageAltText}
                    determineInstalledLength1stOptionLabel={fields.determineInstalledLength1stOptionLabel}
                    determineInstalledLength2ndOptionLabel={fields.determineInstalledLength2ndOptionLabel}
                    determineInstalledLength3rdOptionLabel={fields.determineInstalledLength3rdOptionLabel}
                    watchVideoLabel={fields.watchVideoLabel}
                    stepLabel={fields.stepLabel}
                    step={4}
                />
            )}
            {currentStep.main === 4 && currentStep.sub === 1 && (
                <LengthSelectorScreen
                    onProceedToNextScreen={proceedToNextScreen}
                    onProceedToPreviousScreen={proceedToPreviousScreen}
                    readyshaftCategoryId={readyshaftCategoryId}
                    currentAttributeFilters={attributeFilters}
                    backLabel={fields.backLabel}
                    slideTitle={fields.pageHeading}
                    subText={fields.pageSubText}
                    description={fields.installedCLYokeToCLYokeHeading}
                    additionalText={fields.determineInstalledLengthAdditionalHeading}
                    image={fields.installedCLYokeToCLYokeImage}
                    imageAltText={fields.installedCLYokeToCLYokeImageAltText}
                    leftFacetLabel={fields.installedCLYokeToCLYokeMMLabel}
                    rightFacetLabel={fields.installedCLYokeToCLYokeINLabel}
                    leftNote={fields.determineInstalledLengthLeftNote}
                    rightNote={fields.determineInstalledLengthRightNote}
                    stepLabel={fields.stepLabel}
                    nextLabel={fields.nextLabel}
                    step={4}
                    attributeNameInMillimeters="CL Yoke To CL Yoke (MM)-INST"
                    attributeNameInInches="CL Yoke To CL Yoke (IN)-INST"
                />
            )}
            {currentStep.main === 4 && currentStep.sub === 2 && (
                <LengthSelectorScreen
                    onProceedToNextScreen={proceedToNextScreen}
                    onProceedToPreviousScreen={proceedToPreviousScreen}
                    readyshaftCategoryId={readyshaftCategoryId}
                    currentAttributeFilters={attributeFilters}
                    backLabel={fields.backLabel}
                    slideTitle={fields.pageHeading}
                    subText={fields.pageSubText}
                    description={fields.installedCLYokeToFFHeading}
                    additionalText={fields.determineInstalledLengthAdditionalHeading}
                    image={fields.installedCLYokeToFFImage}
                    imageAltText={fields.installedCLYokeToFFImageAltText}
                    leftFacetLabel={fields.installedCLYokeToFFMMLabel}
                    rightFacetLabel={fields.installedCLYokeToFFINLabel}
                    leftNote={fields.determineInstalledLengthLeftNote}
                    rightNote={fields.determineInstalledLengthRightNote}
                    stepLabel={fields.stepLabel}
                    nextLabel={fields.nextLabel}
                    step={4}
                    attributeNameInMillimeters="CL Yoke To Flange Face (MM)-INST"
                    attributeNameInInches="CL Yoke To Flange Face (IN)-INST"
                />
            )}
            {currentStep.main === 4 && currentStep.sub === 3 && (
                <LengthSelectorScreen
                    onProceedToNextScreen={proceedToNextScreen}
                    onProceedToPreviousScreen={proceedToPreviousScreen}
                    readyshaftCategoryId={readyshaftCategoryId}
                    currentAttributeFilters={attributeFilters}
                    backLabel={fields.backLabel}
                    slideTitle={fields.pageHeading}
                    subText={fields.pageSubText}
                    description={fields.installedFFToFFHeading}
                    additionalText={fields.determineInstalledLengthAdditionalHeading}
                    image={fields.installedFFToFFImage}
                    imageAltText={fields.installedFFToFFImageAltText}
                    leftFacetLabel={fields.installedFFToFFMMLabel}
                    rightFacetLabel={fields.installedFFToFFINLabel}
                    leftNote={fields.determineInstalledLengthLeftNote}
                    rightNote={fields.determineInstalledLengthRightNote}
                    stepLabel={fields.stepLabel}
                    nextLabel={fields.nextLabel}
                    step={4}
                    attributeNameInMillimeters="FF(Flange Face) To FF (MM)-INST"
                    attributeNameInInches="FF(Flange Face) To FF (IN)-INST"
                />
            )}
            {currentStep.main === 5 && (
                <PhaseSelectorScreen
                    onProceedToNextScreen={proceedToNextScreen}
                    onProceedToPreviousScreen={proceedToPreviousScreen}
                    readyshaftCategoryId={readyshaftCategoryId}
                    currentAttributeFilters={attributeFilters}
                    video={fields.selectPhasingVideo}
                    caption={fields.selectPhasingVideoCaption}
                    backLabel={fields.backLabel}
                    slideTitle={fields.pageHeading}
                    subText={fields.pageSubText}
                    description={fields.selectPhasingHeading}
                    image={fields.selectPhasingImage}
                    imageAltText={fields.selectPhasingImageAltText}
                    facetLabel={fields.phasingLabel}
                    leftNote={fields.selectPhasingLeftNote}
                    rightNote={fields.selectPhasingRightNote}
                    watchVideoLabel={fields.watchVideoLabel}
                    stepLabel={fields.stepLabel}
                    nextLabel={fields.nextLabel}
                    step={5}
                />
            )}
            {currentStep.main === 6 && (
                <JointAngleSelectorScreen
                    onProceedToNextScreen={proceedToNextScreen}
                    onProceedToPreviousScreen={proceedToPreviousScreen}
                    readyshaftCategoryId={readyshaftCategoryId}
                    currentAttributeFilters={attributeFilters}
                    video={fields.selectJointAngleVideo}
                    caption={fields.selectJointAngleVideoCaption}
                    backLabel={fields.backLabel}
                    slideTitle={fields.pageHeading}
                    subText={fields.pageSubText}
                    description={fields.selectJointAngleHeading}
                    image={fields.selectJointAngleImage}
                    imageAltText={fields.selectJointAngleImageAltText}
                    facetLabel={fields.jointAngleLabel}
                    leftNote={fields.selectJointAngleLeftNote}
                    rightNote={fields.selectJointAngleRightNote}
                    watchVideoLabel={fields.watchVideoLabel}
                    stepLabel={fields.stepLabel}
                    nextLabel={fields.nextLabel}
                    step={6}
                />
            )}

            {currentStep.main === 7 && (
                <ResultScreen
                    backLabel={fields.backLabel}
                    currentAttributeFilters={attributeFilters}
                    spicerReadyShaftBrandId={spicerReadyShaftBrandId}
                    readyshaftCategoryId={readyshaftCategoryId}
                    productDefaultImage={fields.productDefaultImage}
                    productDefaultImageAltText={fields.productDefaultImageAltText}
                    promotionalImage={fields.promotionalImage}
                    promotionalImageAltText={fields.promotionalImageAltText}
                    promotionalText={fields.promotionalText}
                    promotionalURL={fields.promotionalURL}
                    viewAdditionalDetailLabel={fields.viewAdditionalDetailLabel}
                    onProceedToPreviousScreen={proceedToPreviousScreen}

                />
            )}

        </Page>
    )
};

const mainTab = {
    displayName: "Main Page",
    sortOrder: 0,
};

const selectSeriesTab = {
    displayName: "Select Series (Step 1)",
    sortOrder: 1,
};

const selectUJointStyleTab = {
    displayName: "Select U-Joint Style (Step 2)",
    sortOrder: 2,
};

const determineCollapsedLengthTab = {
    displayName: "Determine Collapsed Length (Step 3)",
    sortOrder: 3,
};

const determineInstalledLengthTab = {
    displayName: "Determine Installed Length (Step 4)",
    sortOrder: 4,
};

const selectPhasingTab = {
    displayName: "Select Phasing (Step 5)",
    sortOrder: 5,
};

const selectJointAngleTab = {
    displayName: "Select Joint Angle (Step 6)",
    sortOrder: 6,
};

const resultTab = {
    displayName: "Result Page",
    sortOrder: 7,
};

const pageModule: PageModule = {
    component: EZIDShortCoupleWorkflowPage,
    definition: {
        displayName: "Short Couple Workflow Page",
        hasEditableTitle: true,
        hasEditableUrlSegment: true,
        pageType: "Content",
        fieldDefinitions: [
            MetaKeywords,
            MetaDescription,
            OpenGraphTitle,
            OpenGraphUrl,
            OpenGraphImage,
            StructuredPageData,
            {
                ...HorizontalRule,
                sortOrder: 199,
            },
            HideHeader,
            HideFooter,
            HideFromSearchEngines,
            HideFromSiteSearch,
            ExcludeFromNavigation,
            ExcludeFromSignInRequired,

            // Main Page
            {
                fieldType: "Translatable",
                name: fields.pageHeading,
                editorTemplate: "TextField",
                displayName: "Page Heading",
                defaultValue: "Spicer ReadyShaft Visual Search",
                tab: mainTab,
            },
            {
                fieldType: "Translatable",
                name: fields.pageSubText,
                editorTemplate: "TextField",
                displayName: "Page Sub Text",
                defaultValue: "Short Couple (No Tubing) Selector",
                tab: mainTab,
            },
            {
                fieldType: "Translatable",
                name: fields.backLabel,
                editorTemplate: "TextField",
                displayName: "Back Button Label",
                defaultValue: "Back",
                tab: mainTab,
            },
            {
                name: fields.shortCouleSelectionUrl,
                fieldType: "Translatable",
                displayName: "Short Couple Selection URL",
                editorTemplate: "LinkField",
                defaultValue: { type: "Url", value: "" },
                tab: mainTab,
            },
            {
                fieldType: "Translatable",
                name: fields.watchVideoLabel,
                editorTemplate: "TextField",
                displayName: "Watch Video Label",
                defaultValue: "Watch The Video",
                tab: mainTab,
            },
            {
                fieldType: "Translatable",
                name: fields.nextLabel,
                editorTemplate: "TextField",
                displayName: "Next Button Label",
                defaultValue: "Next",
                tab: mainTab,
            },
            {
                fieldType: "Translatable",
                name: fields.stepLabel,
                editorTemplate: "TextField",
                displayName: "Step Label",
                defaultValue: "Step",
                tab: mainTab,
            },

            // Step 1 - Select Series
            {
                fieldType: "Translatable",
                name: fields.selectSeriesHeading,
                editorTemplate: "TextField",
                displayName: "Select Series Heading",
                defaultValue: "Select Series",
                tab: selectSeriesTab,
            },
            {
                fieldType: "Translatable",
                name: fields.seriesLabel,
                editorTemplate: "TextField",
                displayName: "Series Label",
                defaultValue: "Series",
                tab: selectSeriesTab,
            },
            {
                name: fields.selectSeriesImage,
                fieldType: "Translatable",
                displayName: "Select Series Image",
                editorTemplate: "ImagePickerField",
                defaultValue: "",
                tab: selectSeriesTab,
            },
            {
                fieldType: "Translatable",
                name: fields.selectSeriesImageAltText,
                editorTemplate: "TextField",
                displayName: "Select Series Image Alt Text",
                defaultValue: "",
                tab: selectSeriesTab,
            },
            {
                fieldType: "Translatable",
                name: fields.selectSeriesLeftNote,
                editorTemplate: "RichTextField",
                displayName: "Select Series Left Note",
                defaultValue: "",
                tab: selectSeriesTab,
            },
            {
                fieldType: "Translatable",
                name: fields.selectSeriesRightNote,
                editorTemplate: "RichTextField",
                displayName: "Select Series Right Note",
                defaultValue: "",
                tab: selectSeriesTab,
            },
            {
                name: fields.selectSeriesVideo,
                fieldType: "Translatable",
                displayName: "Select Series Video URL",
                editorTemplate: "LinkField",
                defaultValue: { type: "Url", value: "" },
                tab: selectSeriesTab,
            },
            {
                name: fields.selectSeriesVideoCaption,
                fieldType: "Translatable",
                displayName: "Select Series Video Caption URL",
                editorTemplate: "LinkField",
                defaultValue: { type: "Url", value: "" },
                tab: selectSeriesTab,
            },

            // Step 2 - Select U-Joint Style
            {
                fieldType: "Translatable",
                name: fields.selectUJointStyleHeading,
                editorTemplate: "TextField",
                displayName: "Select U-Joint Style Heading",
                defaultValue: "Select U-Joint Style",
                tab: selectUJointStyleTab,
            },
            {
                fieldType: "Translatable",
                name: fields.uJointStyleLabel,
                editorTemplate: "TextField",
                displayName: "U-Joint Style Label",
                defaultValue: "U-Joint Style",
                tab: selectUJointStyleTab,
            },
            {
                name: fields.selectUJointStyleImage,
                fieldType: "Translatable",
                displayName: "Select U-Joint Style Image",
                editorTemplate: "ImagePickerField",
                defaultValue: "",
                tab: selectUJointStyleTab,
            },
            {
                fieldType: "Translatable",
                name: fields.selectUJointStyleImageAltText,
                editorTemplate: "TextField",
                displayName: "Select U-Joint Style Image Alt Text",
                defaultValue: "",
                tab: selectUJointStyleTab,
            },
            {
                fieldType: "Translatable",
                name: fields.selectUJointStyleLeftNote,
                editorTemplate: "RichTextField",
                displayName: "Select U-Joint Style Left Note",
                defaultValue: "",
                tab: selectUJointStyleTab,
            },
            {
                fieldType: "Translatable",
                name: fields.selectUJointStyleRightNote,
                editorTemplate: "RichTextField",
                displayName: "Select U-Joint Style Right Note",
                defaultValue: "",
                tab: selectUJointStyleTab,
            },
            {
                name: fields.selectUJointStyleVideo,
                fieldType: "Translatable",
                displayName: "Select U-Joint Style Video URL",
                editorTemplate: "LinkField",
                defaultValue: { type: "Url", value: "" },
                tab: selectUJointStyleTab,
            },
            {
                name: fields.selectUJointStyleVideoCaption,
                fieldType: "Translatable",
                displayName: "Select U-Joint Style Video Caption URL",
                editorTemplate: "LinkField",
                defaultValue: { type: "Url", value: "" },
                tab: selectUJointStyleTab,
            },

            // Step 3 - Determine Collapsed Length
            {
                fieldType: "Translatable",
                name: fields.determineCollapsedLengthHeading,
                editorTemplate: "TextField",
                displayName: "Determine Collapsed Length Heading",
                defaultValue: "How Would You Like To Determine Your Collapsed Length?",
                tab: determineCollapsedLengthTab,
            },
            {
                name: fields.determineCollapsedLengthImage,
                fieldType: "Translatable",
                displayName: "Determine Collapsed Length Image",
                editorTemplate: "ImagePickerField",
                defaultValue: "",
                tab: determineCollapsedLengthTab,
            },
            {
                fieldType: "Translatable",
                name: fields.determineCollapsedLengthImageAltText,
                editorTemplate: "TextField",
                displayName: "Determine Collapsed Length Image Alt Text",
                defaultValue: "",
                tab: determineCollapsedLengthTab,
            },
            {
                fieldType: "Translatable",
                name: fields.determineCollapsedLength1stOptionLabel,
                editorTemplate: "TextField",
                displayName: "Determine Collapsed Length 1st Option Label",
                tooltip: "Unknown Collapsed Length Option Label",
                defaultValue: "1. Unknown / Not Available",
                tab: determineCollapsedLengthTab,
            },
            {
                fieldType: "Translatable",
                name: fields.determineCollapsedLength2ndOptionLabel,
                editorTemplate: "TextField",
                displayName: "Determine Collapsed Length 2nd Option Label",
                tooltip: "Center of U-Joint to Center of U-Joint (Collapsed) Option Label",
                defaultValue: "2. Center of U-Joint to Center of U-Joint (Collapsed)",
                tab: determineCollapsedLengthTab,
            },
            {
                fieldType: "Translatable",
                name: fields.determineCollapsedLength3rdOptionLabel,
                editorTemplate: "TextField",
                displayName: "Determine Collapsed Length 3rd Option Label",
                tooltip: "Flange Face to Flange Face (Collapsed) Option Label",
                defaultValue: "3. Flange Face to Flange Face (Collapsed)",
                tab: determineCollapsedLengthTab,
            },
            {
                fieldType: "Translatable",
                name: fields.determineCollapsedLength4thOptionLabel,
                editorTemplate: "TextField",
                displayName: "Determine Collapsed Length 4th Option Label",
                tooltip: "Center of Yoke to Flange Face (Collapsed) Option Label",
                defaultValue: "4. Center of Yoke to Flange Face (Collapsed)",
                tab: determineCollapsedLengthTab,
            },
            {
                name: fields.determineCollapsedLengthVideo,
                fieldType: "Translatable",
                displayName: "Determine Collapsed Length Video URL",
                editorTemplate: "LinkField",
                defaultValue: { type: "Url", value: "" },
                tab: determineCollapsedLengthTab,
            },
            {
                name: fields.determineCollapsedLengthVideoCaption,
                fieldType: "Translatable",
                displayName: "Determine Collapsed Length Video Caption URL",
                editorTemplate: "LinkField",
                defaultValue: { type: "Url", value: "" },
                tab: determineCollapsedLengthTab,
            },
            {
                fieldType: "Translatable",
                name: fields.determineCollapsedLengthLeftNote,
                editorTemplate: "RichTextField",
                displayName: "Determine Collapsed Length Left Note",
                defaultValue: "",
                tab: determineCollapsedLengthTab,
            },
            {
                fieldType: "Translatable",
                name: fields.determineCollapsedLengthRightNote,
                editorTemplate: "RichTextField",
                displayName: "Determine Collapsed Length Right Note",
                defaultValue: "",
                tab: determineCollapsedLengthTab,
            },

            // Step 3.1 - Select Center of U-Joint to Center of U-Joint (Collapsed)
            {
                fieldType: "Translatable",
                name: fields.collapsedCLYokeToCLYokeHeading,
                editorTemplate: "TextField",
                displayName: "Collapsed CL Yoke to CL Yoke Heading",
                defaultValue: "Select Center of U-Joint to Center of U-Joint (Collapsed)",
                tab: determineCollapsedLengthTab,
            },
            {
                name: fields.collapsedCLYokeToCLYokeImage,
                fieldType: "Translatable",
                displayName: "Collapsed CL Yoke to CL Yoke Image",
                editorTemplate: "ImagePickerField",
                defaultValue: "",
                tab: determineCollapsedLengthTab,
            },
            {
                fieldType: "Translatable",
                name: fields.collapsedCLYokeToCLYokeImageAltText,
                editorTemplate: "TextField",
                displayName: "Collapsed CL Yoke to CL Yoke Image Alt Text",
                defaultValue: "",
                tab: determineCollapsedLengthTab,
            },
            {
                fieldType: "Translatable",
                name: fields.collapsedCLYokeToCLYokeMMLabel,
                editorTemplate: "TextField",
                displayName: "Collapsed CL Yoke to CL Yoke (MM) Label",
                defaultValue: "CL Yoke To CL Yoke (MM)-COLL",
                tab: determineCollapsedLengthTab,
            },
            {
                fieldType: "Translatable",
                name: fields.collapsedCLYokeToCLYokeINLabel,
                editorTemplate: "TextField",
                displayName: "Collapsed CL Yoke to CL Yoke (IN) Label",
                defaultValue: "CL Yoke To CL Yoke (IN)-COLL",
                tab: determineCollapsedLengthTab,
            },

            // Step 3.2 - Select Flange Face to Flange Face (Collapsed)
            {
                fieldType: "Translatable",
                name: fields.collapsedFFToFFHeading,
                editorTemplate: "TextField",
                displayName: "Collapsed FF to FF Heading",
                defaultValue: "Select Flange Face to Flange Face (Collapsed)",
                tab: determineCollapsedLengthTab,
            },
            {
                name: fields.collapsedFFToFFImage,
                fieldType: "Translatable",
                displayName: "Collapsed FF to FF Image",
                editorTemplate: "ImagePickerField",
                defaultValue: "",
                tab: determineCollapsedLengthTab,
            },
            {
                fieldType: "Translatable",
                name: fields.collapsedFFToFFImageAltText,
                editorTemplate: "TextField",
                displayName: "Collapsed FF to FF Image Alt Text",
                defaultValue: "",
                tab: determineCollapsedLengthTab,
            },
            {
                fieldType: "Translatable",
                name: fields.collapsedFFToFFMMLabel,
                editorTemplate: "TextField",
                displayName: "Collapsed FF to FF (MM) Label",
                defaultValue: "FF(Flange Face) To FF (MM)-COLL",
                tab: determineCollapsedLengthTab,
            },
            {
                fieldType: "Translatable",
                name: fields.collapsedFFToFFINLabel,
                editorTemplate: "TextField",
                displayName: "Collapsed FF to FF (IN) Label",
                defaultValue: "FF(Flange Face) To FF (IN)-COLL",
                tab: determineCollapsedLengthTab,
            },

            // Step 3.3 - Select Center of Yoke to Flange Face (Collapsed)
            {
                fieldType: "Translatable",
                name: fields.collapsedCLYokeToFFHeading,
                editorTemplate: "TextField",
                displayName: "Collapsed CL Yoke to FF Heading",
                defaultValue: "Select Center of Yoke to Flange Face (Collapsed)",
                tab: determineCollapsedLengthTab,
            },
            {
                name: fields.collapsedCLYokeToFFImage,
                fieldType: "Translatable",
                displayName: "Collapsed CL Yoke to FF Image",
                editorTemplate: "ImagePickerField",
                defaultValue: "",
                tab: determineCollapsedLengthTab,
            },
            {
                fieldType: "Translatable",
                name: fields.collapsedCLYokeToFFImageAltText,
                editorTemplate: "TextField",
                displayName: "Collapsed CL Yoke to FF Image Alt Text",
                defaultValue: "",
                tab: determineCollapsedLengthTab,
            },
            {
                fieldType: "Translatable",
                name: fields.collapsedCLYokeToFFMMLabel,
                editorTemplate: "TextField",
                displayName: "Collapsed CL Yoke to FF (MM) Label",
                defaultValue: "CL Yoke To FF (MM)-COLL",
                tab: determineCollapsedLengthTab,
            },
            {
                fieldType: "Translatable",
                name: fields.collapsedCLYokeToFFINLabel,
                editorTemplate: "TextField",
                displayName: "Collapsed CL Yoke to FF (IN) Label",
                defaultValue: "CL Yoke To FF (IN)-COLL",
                tab: determineCollapsedLengthTab,
            },

            // Step 4 - Determine Installed Length
            {
                fieldType: "Translatable",
                name: fields.determineInstalledLengthHeading,
                editorTemplate: "TextField",
                displayName: "Determine Installed Length Heading",
                defaultValue: "How Would You Like To Determine Your Installed Length?",
                tab: determineInstalledLengthTab,
            },
            {
                fieldType: "Translatable",
                name: fields.determineInstalledLengthAdditionalHeading,
                editorTemplate: "TextField",
                displayName: "Determine Installed Length Additional Heading",
                defaultValue: "These dimensions are taken off the truck, your installed measurement may vary slightly",
                tab: determineInstalledLengthTab,
            },
            {
                name: fields.determineInstalledLengthImage,
                fieldType: "Translatable",
                displayName: "Determine Installed Length Image",
                editorTemplate: "ImagePickerField",
                defaultValue: "",
                tab: determineInstalledLengthTab,
            },
            {
                fieldType: "Translatable",
                name: fields.determineInstalledLengthImageAltText,
                editorTemplate: "TextField",
                displayName: "Determine Installed Length Image Alt Text",
                defaultValue: "",
                tab: determineInstalledLengthTab,
            },
            {
                fieldType: "Translatable",
                name: fields.determineInstalledLength1stOptionLabel,
                editorTemplate: "TextField",
                displayName: "Determine Installed Length 1st Option Label",
                tooltip: "CL Yoke To CL Yoke Installed Length Option Label",
                defaultValue: "1. Centerline of Yoke to Centerline of Yoke (Installed)",
                tab: determineInstalledLengthTab,
            },
            {
                fieldType: "Translatable",
                name: fields.determineInstalledLength2ndOptionLabel,
                editorTemplate: "TextField",
                displayName: "Determine Installed Length 2nd Option Label",
                tooltip: "CL Yoke To FF (Installed) Option Label",
                defaultValue: "2. Centerline of Yoke to Flange Face (Installed)",
                tab: determineInstalledLengthTab,
            },
            {
                fieldType: "Translatable",
                name: fields.determineInstalledLength3rdOptionLabel,
                editorTemplate: "TextField",
                displayName: "Determine Installed Length 3rd Option Label",
                tooltip: "FF To FF (Installed) Option Label",
                defaultValue: "3. Flange Face to Flange Face (Installed)",
                tab: determineInstalledLengthTab,
            },
            {
                name: fields.determineInstalledLengthVideo,
                fieldType: "Translatable",
                displayName: "Determine Installed Length Video URL",
                editorTemplate: "LinkField",
                defaultValue: { type: "Url", value: "" },
                tab: determineInstalledLengthTab,
            },
            {
                name: fields.determineInstalledLengthVideoCaption,
                fieldType: "Translatable",
                displayName: "Determine Installed Length Video Caption URL",
                editorTemplate: "LinkField",
                defaultValue: { type: "Url", value: "" },
                tab: determineInstalledLengthTab,
            },
            {
                fieldType: "Translatable",
                name: fields.determineInstalledLengthLeftNote,
                editorTemplate: "RichTextField",
                displayName: "Determine Installed Length Left Note",
                defaultValue: "",
                tab: determineInstalledLengthTab,
            },
            {
                fieldType: "Translatable",
                name: fields.determineInstalledLengthRightNote,
                editorTemplate: "RichTextField",
                displayName: "Determine Installed Length Right Note",
                defaultValue: "",
                tab: determineInstalledLengthTab,
            },

            // Step 4.1 - Select Center of Yoke to Center of Yoke (Installed)
            {
                fieldType: "Translatable",
                name: fields.installedCLYokeToCLYokeHeading,
                editorTemplate: "TextField",
                displayName: "Installed CL Yoke to CL Yoke Heading",
                defaultValue: "Select Centerline of Yoke to Centerline of Yoke (Installed)",
                tab: determineInstalledLengthTab,
            },
            {
                name: fields.installedCLYokeToCLYokeImage,
                fieldType: "Translatable",
                displayName: "Installed CL Yoke to CL Yoke Image",
                editorTemplate: "ImagePickerField",
                defaultValue: "",
                tab: determineInstalledLengthTab,
            },
            {
                fieldType: "Translatable",
                name: fields.installedCLYokeToCLYokeImageAltText,
                editorTemplate: "TextField",
                displayName: "Installed CL Yoke to CL Yoke Image Alt Text",
                defaultValue: "",
                tab: determineInstalledLengthTab,
            },
            {
                fieldType: "Translatable",
                name: fields.installedCLYokeToCLYokeMMLabel,
                editorTemplate: "TextField",
                displayName: "Installed CL Yoke to CL Yoke (MM) Label",
                defaultValue: "CL Yoke To CL Yoke (MM)-INST",
                tab: determineInstalledLengthTab,
            },
            {
                fieldType: "Translatable",
                name: fields.installedCLYokeToCLYokeINLabel,
                editorTemplate: "TextField",
                displayName: "Installed CL Yoke to CL Yoke (IN) Label",
                defaultValue: "CL Yoke To CL Yoke (IN)-INST",
                tab: determineInstalledLengthTab,
            },
            // Step 4.2 - Select Center of Yoke to Flange Face (Installed)
            {
                fieldType: "Translatable",
                name: fields.installedCLYokeToFFHeading,
                editorTemplate: "TextField",
                displayName: "Installed CL Yoke to FF Heading",
                defaultValue: "Select Centerline of Yoke to Flange Face (Installed)",
                tab: determineInstalledLengthTab,
            },
            {
                name: fields.installedCLYokeToFFImage,
                fieldType: "Translatable",
                displayName: "Installed CL Yoke to FF Image",
                editorTemplate: "ImagePickerField",
                defaultValue: "",
                tab: determineInstalledLengthTab,
            },
            {
                fieldType: "Translatable",
                name: fields.installedCLYokeToFFImageAltText,
                editorTemplate: "TextField",
                displayName: "Installed CL Yoke to FF Image Alt Text",
                defaultValue: "",
                tab: determineInstalledLengthTab,
            },
            {
                fieldType: "Translatable",
                name: fields.installedCLYokeToFFMMLabel,
                editorTemplate: "TextField",
                displayName: "Installed CL Yoke to FF (MM) Label",
                defaultValue: "CL Yoke To Flange Face (MM)-INST",
                tab: determineInstalledLengthTab,
            },
            {
                fieldType: "Translatable",
                name: fields.installedCLYokeToFFINLabel,
                editorTemplate: "TextField",
                displayName: "Installed CL Yoke to FF (IN) Label",
                defaultValue: "CL Yoke To Flange Face (IN)-INST",
                tab: determineInstalledLengthTab,
            },

            // Step 4.3 - Select Flange Face to Flange Face (Installed)
            {
                fieldType: "Translatable",
                name: fields.installedFFToFFHeading,
                editorTemplate: "TextField",
                displayName: "Installed FF to FF Heading",
                defaultValue: "Select Flange Face to Flange Face (Installed)",
                tab: determineInstalledLengthTab,
            },
            {
                name: fields.installedFFToFFImage,
                fieldType: "Translatable",
                displayName: "Installed FF to FF Image",
                editorTemplate: "ImagePickerField",
                defaultValue: "",
                tab: determineInstalledLengthTab,
            },
            {
                fieldType: "Translatable",
                name: fields.installedFFToFFImageAltText,
                editorTemplate: "TextField",
                displayName: "Installed FF to FF Image Alt Text",
                defaultValue: "",
                tab: determineInstalledLengthTab,
            },
            {
                fieldType: "Translatable",
                name: fields.installedFFToFFMMLabel,
                editorTemplate: "TextField",
                displayName: "Installed FF to FF (MM) Label",
                defaultValue: "FF(Flange Face) To FF (MM)-INST",
                tab: determineInstalledLengthTab,
            },
            {
                fieldType: "Translatable",
                name: fields.installedFFToFFINLabel,
                editorTemplate: "TextField",
                displayName: "Installed FF to FF (IN) Label",
                defaultValue: "FF(Flange Face) To FF (IN)-INST",
                tab: determineInstalledLengthTab,
            },

            // Step 5 - Select Phasing
            {
                fieldType: "Translatable",
                name: fields.selectPhasingHeading,
                editorTemplate: "TextField",
                displayName: "Select Phasing Heading",
                defaultValue: "Select Phasing",
                tab: selectPhasingTab,
            },
            {
                fieldType: "Translatable",
                name: fields.phasingLabel,
                editorTemplate: "TextField",
                displayName: "Select Phasing Label",
                defaultValue: "Phase (Yes/No)",
                tab: selectPhasingTab,
            },
            {
                name: fields.selectPhasingImage,
                fieldType: "Translatable",
                displayName: "Select Phasing Image",
                editorTemplate: "ImagePickerField",
                defaultValue: "",
                tab: selectPhasingTab,
            },
            {
                fieldType: "Translatable",
                name: fields.selectPhasingImageAltText,
                editorTemplate: "TextField",
                displayName: "Select Phasing Image Alt Text",
                defaultValue: "",
                tab: selectPhasingTab,
            },
            {
                fieldType: "Translatable",
                name: fields.selectPhasingLeftNote,
                editorTemplate: "RichTextField",
                displayName: "Select Phasing Left Note",
                defaultValue: "",
                tab: selectPhasingTab,
            },
            {
                fieldType: "Translatable",
                name: fields.selectPhasingRightNote,
                editorTemplate: "RichTextField",
                displayName: "Select Phasing Right Note",
                defaultValue: "",
                tab: selectPhasingTab,
            },
            {
                name: fields.selectPhasingVideo,
                fieldType: "Translatable",
                displayName: "Select Phasing Video URL",
                editorTemplate: "LinkField",
                defaultValue: { type: "Url", value: "" },
                tab: selectPhasingTab,
            },
            {
                name: fields.selectPhasingVideoCaption,
                fieldType: "Translatable",
                displayName: "Select Phasing Video Caption URL",
                editorTemplate: "LinkField",
                defaultValue: { type: "Url", value: "" },
                tab: selectPhasingTab,
            },

            // Step 6 - Select Joint Angle
            {
                fieldType: "Translatable",
                name: fields.selectJointAngleHeading,
                editorTemplate: "TextField",
                displayName: "Select Joint Angle Heading",
                defaultValue: "Select Yoke Angle",
                tab: selectJointAngleTab,
            },
            {
                fieldType: "Translatable",
                name: fields.jointAngleLabel,
                editorTemplate: "TextField",
                displayName: "Joint Angle Label",
                defaultValue: "Joint Angle",
                tab: selectJointAngleTab,
            },
            {
                name: fields.selectJointAngleImage,
                fieldType: "Translatable",
                displayName: "Select Joint Angle Image",
                editorTemplate: "ImagePickerField",
                defaultValue: "",
                tab: selectJointAngleTab,
            },
            {
                fieldType: "Translatable",
                name: fields.selectJointAngleImageAltText,
                editorTemplate: "TextField",
                displayName: "Select Joint Angle Image Alt Text",
                defaultValue: "",
                tab: selectJointAngleTab,
            },
            {
                fieldType: "Translatable",
                name: fields.selectJointAngleLeftNote,
                editorTemplate: "RichTextField",
                displayName: "Select Joint Angle Left Note",
                defaultValue: "",
                tab: selectJointAngleTab,
            },
            {
                fieldType: "Translatable",
                name: fields.selectJointAngleRightNote,
                editorTemplate: "RichTextField",
                displayName: "Select Joint Angle Right Note",
                defaultValue: "",
                tab: selectJointAngleTab,
            },
            {
                name: fields.selectJointAngleVideo,
                fieldType: "Translatable",
                displayName: "Select Joint Angle Video URL",
                editorTemplate: "LinkField",
                defaultValue: { type: "Url", value: "" },
                tab: selectJointAngleTab,
            },
            {
                name: fields.selectJointAngleVideoCaption,
                fieldType: "Translatable",
                displayName: "Select Joint Angle Video Caption URL",
                editorTemplate: "LinkField",
                defaultValue: { type: "Url", value: "" },
                tab: selectJointAngleTab,
            },

            // Result Page
            {
                fieldType: "Translatable",
                name: fields.productDefaultImage,
                editorTemplate: "ImagePickerField",
                displayName: "Product Default Image",
                defaultValue: "",
                tab: resultTab,
            },
            {
                fieldType: "Translatable",
                name: fields.productDefaultImageAltText,
                editorTemplate: "TextField",
                displayName: "Product Default Image Alt Text",
                defaultValue: "",
                tab: resultTab,
            },
            {
                fieldType: "Translatable",
                name: fields.promotionalImage,
                editorTemplate: "ImagePickerField",
                displayName: "Promotional Image",
                defaultValue: "",
                tab: resultTab,
            },
            {
                name: fields.promotionalImageAltText,
                fieldType: "Translatable",
                displayName: "Promotional Image Alt Text",
                editorTemplate: "TextField",
                defaultValue: "",
                tab: resultTab,
            },
            {
                name: fields.promotionalText,
                fieldType: "Translatable",
                displayName: "Promotional Text",
                editorTemplate: "TextField",
                defaultValue: "",
                tab: resultTab,
            },
            {
                name: fields.promotionalURL,
                fieldType: "Translatable",
                displayName: "Promotional URL",
                editorTemplate: "LinkField",
                defaultValue: { type: "Url", value: "" },
                tab: resultTab,
            },
            {
                fieldType: "Translatable",
                name: fields.viewAdditionalDetailLabel,
                editorTemplate: "TextField",
                displayName: "View Additional Detail Label",
                defaultValue: "View Additional Detail",
                tab: resultTab,
            },

        ],
    },
};

export default pageModule;
